/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './muteConvo.defs.js'
export * as $defs from './muteConvo.defs.js'
